import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

export const Footer = () => {
  const [links, setLinks] = useState<Array<{ title: string; path: string }>>([
    { title: "首页", path: "/" },
    { title: "关于我们", path: "/about" },
    { title: "联系我们", path: "/contact" }
  ]);
  const [copyright, setCopyright] = useState("© 2024 成人认证系统. 保留所有权利.");

  useEffect(() => {
    const fetchContent = async () => {
      console.log("Fetching footer content...");
      
      try {
        // Fetch footer links
        const { data: linksData, error: linksError } = await supabase
          .from('site_content')
          .select('content')
          .eq('key', 'footer_links')
          .maybeSingle();

        if (linksError) {
          console.error("Error fetching footer links:", linksError);
        } else {
          console.log("Received footer links data:", linksData);
          if (linksData?.content) {
            try {
              const parsedLinks = JSON.parse(linksData.content);
              console.log("Successfully parsed footer links:", parsedLinks);
              if (Array.isArray(parsedLinks) && parsedLinks.length > 0) {
                setLinks(parsedLinks);
              }
            } catch (e) {
              console.error("Error parsing footer links JSON:", e);
            }
          }
        }

        // Fetch copyright text
        const { data: copyrightData, error: copyrightError } = await supabase
          .from('site_content')
          .select('content')
          .eq('key', 'footer_copyright')
          .maybeSingle();

        if (copyrightError) {
          console.error("Error fetching copyright:", copyrightError);
        } else {
          console.log("Received copyright data:", copyrightData);
          if (copyrightData?.content) {
            setCopyright(copyrightData.content);
          }
        }
      } catch (error) {
        console.error("Unexpected error in fetchContent:", error);
      }
    };

    fetchContent();
  }, []);

  return (
    <footer className="mt-16 border-t border-white/10 py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center space-y-4">
          <nav className="flex flex-wrap justify-center gap-8">
            {links.map((link, index) => (
              <Link
                key={index}
                to={link.path}
                className="text-gray-400 hover:text-white transition-colors"
              >
                {link.title}
              </Link>
            ))}
          </nav>
          <p className="text-gray-500 text-sm text-center">
            {copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};